import './application';

require('jquery-expander')(window.$);

import '@javascript/main';
